<!--
 * @Description: 关于我们
 * @Author: mileS
 * @Date: 2019-08-09 10:26:26
 * @LastEditTime: 2019-08-15 22:21:25
 * @LastEditors: 2020-06-10 16:22:07
 -->
<template>
  <div class="subject_math_container">
    <Header/>
    <div class="content">
      <div class="menu" id="menu">
        <ul>
          <li class="item" v-for="(item, index) in navList" :key="`nav-li${index}`" @click="jump(index)"
              :class="{'active': currentIndex === index }">
            <span class="range-icon" :class="{'active': currentIndex === index }"/>
            <span class="title">{{item.title}}</span>
          </li>
        </ul>
      </div>
      <div class="content-list">
        <div class="school">
          <p class="title">致力于成为全球优质科技教育产品供应平台</p>
          <p class="des">
            未来魔法校基于好未来直营校全国办学实践经验，为K12校外培训机构提供双师课堂、AI教室、内容平台等解决方案，向行业输出北京主讲、优选外教、优质教研、教学工具、运营支持及系统服务，为合作机构解决教学、办学及信息化问题，助力其全面提升核心竞争力。          </p>
        </div>
        <div class="government">
          <p class="title">好未来产品在影响力机构的获奖情况</p>
          <ul class="government-data-list">
            <li v-for="(item, index) in dataList" :key="index" class="item">
              <img :src="item.pic" alt="" class="pic">
              <p class="des">{{ item.content }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headBanner from '@/components/global/headBanner'
import { dataList, navList } from './assets/data'
import Header from './components/header'

export default {
  components: { headBanner, Header },
  data () {
    return {
      dataList, // 数据集合
      navList, // 左侧菜单导航列表
      currentIndex: 0 // 左侧菜单active索引
    }
  },
  methods: {
    /**
     * @Desc 滑动
     * @return {Object} e 对象
     * */
    dataScroll (e) {
      const { scrollTop } = e.srcElement.scrollingElement
      this.currentIndex = scrollTop < 1040 ? 0 : 1
      this.menuFix(scrollTop)
    },

    /**
     * @Desc 点击菜单 滑动
     * @params {Number} 索引
     * */
    jump (index) {
      this.windowScroll(index === 0 ? 640 : 1040)
    },

    /**
     * @Desc 菜单固定
     * */
    menuFix (scrollTop) {
      const menu = document.getElementById('menu')
      if (scrollTop >= 800) {
        menu.style.position = 'fixed'
        menu.style.top = '100px'
      } else {
        menu.style.position = 'absolute'
        menu.style.top = '0'
      }
    },

    /**
     * @Desc 窗口滑动
     * @params {Number} num 滑动距离
     * @return {String} theme
     * */
    windowScroll (num, theme = 'smooth') {
      window.scrollTo({
        top: num,
        behavior: theme
      })
    }
  },
  mounted () {
    window.addEventListener('scroll', this.dataScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.dataScroll)
  }
}
</script>

<style scoped lang="scss">
.subject_math_container {
  margin: 0 auto;
  padding-bottom: 50px;
  background: url("https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-web/img/download_bg.png") no-repeat top center #F8F9FD;
  background-size: 100% 420px;
  .content{
    position: relative;
    margin: 394px auto 0 auto;
    width: 1106px;
    display: flex;
    .menu{
      position: absolute;
      background: #ffffff;
      margin-right: 20px;
      padding: 20px 0 20px 20px;
      width: 200px;
      .item{
        position: relative;
        list-style:none;
        font-size:14px;
        font-weight:600;
        line-height:20px;
        padding: 20px 0 20px 28px;
        text-align: left;
        cursor: pointer;
        &:after{
          position: absolute;
          content: '';
          height: 100%;
          width: 0;
          left: 8px;
          border-left: 1px solid #BFBFBF;
        }
        &:first-child:after{
          top: 29px;
        }
        &:last-child:after{
          bottom: 31px;
        }
        &.active{
          color: #0081FF;
        }
        .range-icon{
          position: absolute;
          left: 1px;
          top: 23px;
          width: 15px;
          height: 15px;
          background: url("../../assets/pngs/scroll-default.png") no-repeat center center;
          background-size:5px 5px;
          z-index: 2;
          &.active{
            background: url("../../assets/pngs/scroll-active.png") no-repeat center center;
            background-size: 15px 15px;
          }
        }
      }
    }
    .content-list{
      padding: 50px;
      margin-left: 220px;
      flex: 1;
      background: #ffffff;
      .title{
        font-size:22px;
        font-weight:600;
        color:rgba(40,40,40,1);
        line-height:30px;
        text-align: left;
      }
      .des{
        font-size:16px;
        font-weight:400;
        color:rgba(40,40,40,1);
        line-height:26px;
        text-align: left;
      }
      .school{
        margin-bottom: 50px;
        padding-right: 250px;
        background: url('../../assets/pngs/logo.png') no-repeat right center;
        background-size: 157px 77px;
        .title{
          margin-bottom: 16px;
        }
      }
      .government{
        .title{
          margin-bottom: 20px;
        }
        .government-data-list{
          padding-left: 0;
          .item{
            display: flex;
            margin: 40px 0;
            .pic{
              margin-right: 50px;
              width:326px;
              height:200px;
              border-radius:4px;
            }
            .des{
              flex: 1;
            }
          }
        }
      }
    }
  }
}
</style>
